import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sidebar-logo',
  templateUrl: './sidebar-logo.component.html',
  styleUrls: ["./sidebar-logo.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainSidebarLogoComponent {}
